import { render, staticRenderFns } from "./WaitingConversationDescription.vue?vue&type=template&id=a260b2e6&scoped=true"
import script from "./WaitingConversationDescription.vue?vue&type=script&lang=js"
export * from "./WaitingConversationDescription.vue?vue&type=script&lang=js"
import style0 from "./WaitingConversationDescription.vue?vue&type=style&index=0&id=a260b2e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a260b2e6",
  null
  
)

export default component.exports